import {Component, Inject} from "@angular/core";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {find} from "lodash-es";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FelloVisitorVariables} from "fello-model";

export interface HomeFeatureOption {
  name: string;
  value: string;
  selected?: boolean;
}

@Component({
  selector: "app-que-home-features",
  templateUrl: "./que-home-features.component.html",
  styleUrls: ["./que-home-features.component.scss"]
})
export class QueHomeFeaturesComponent extends QuestionCardDirective {
  homeFeatureOptions: HomeFeatureOption[] = [
    {
      name: "HOA",
      value: "HOA",
      selected: false
    },
    {
      name: "Well water",
      value: "Well water",
      selected: false
    },
    {
      name: "Septic system",
      value: "Septic system",
      selected: false
    },
    {
      name: "Solar panels",
      value: "Solar panels",
      selected: false
    },
    {
      name: "In-ground pool",
      value: "Swimming pool",
      selected: false
    }
    // {
    //   name: "Home security system",
    //   value: "Home security system",
    //   selected: false
    // },
    // {
    //   name: "Hot tub / Spa",
    //   value: "Hot tub / Spa",
    //   selected: false
    // }
  ];

  constructor(public offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
    this.updateFieldValue("HOA", this.offerJourney.vars.hoa);
    this.updateFieldValue("Well water", this.offerJourney.vars.wellWater);
    this.updateFieldValue("Septic system", this.offerJourney.vars.septicSystem);
    this.updateFieldValue("Solar panels", this.offerJourney.vars.solarPanels);
    this.updateFieldValue("In-ground pool", this.offerJourney.vars.swimmingPool);
    // this.updateFieldValue("Home security system", this.offerJourney.vars.homeSecurity);
    // this.updateFieldValue("Hot tub / Spa", this.offerJourney.vars.hotTubSpa);
  }

  updateFieldValue(fieldName: string, value?: boolean): void {
    if (value) {
      const field = find(this.homeFeatureOptions, {name: fieldName})!;
      field.selected = value;
    }
  }

  getFieldValue(fieldName: string): boolean | undefined {
    const field = find(this.homeFeatureOptions, {name: fieldName})!;
    return field.selected;
  }

  next(): void {
    const vars: FelloVisitorVariables = {
      hoa: this.getFieldValue("HOA"),
      wellWater: this.getFieldValue("Well water"),
      septicSystem: this.getFieldValue("Septic system"),
      solarPanels: this.getFieldValue("Solar panels"),
      swimmingPool: this.getFieldValue("In-ground pool")
      // homeSecurity: this.getFieldValue("Home security system"),
      // hotTubSpa: this.getFieldValue("Hot tub / Spa")
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }
}
